module.exports = __webpack_public_path__ + "img/user_ava.f3a0504a.png";